import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { Button, ButtonGroup, Row, Col } from 'react-bootstrap';
import DialogBox from 'components/shared/DialogBox';
import ConfirmationModal from '../../submission/components/ConfirmationModal';
import { FormBuilder, SelectSearchContainer } from '../../components/shared';
import { validation } from '../../submissions';
import * as utils from '../../utils';
import { fetchBrokerages } from '../../brokerages/actions';
import { impersonateBrokerId } from '../../person/actions.js';
import {
    CHANGE_SUBMISSION_STATUS,
    SUBMISSION_STATUS,
    CHANGE_SUBMISSION
} from 'app/constants/submission';

import routes from '../../constants/routes'

import { getRatingProduct } from '../../../config/RatingProducts';
import withSubmission from '../../submissions/withSubmission';
import { getSubjectivities, updateSubjectivities } from '../../submissions/components/getSubjectivities';
import { getExclusionU650 } from '../../submissions/components/getExclusionU650';
import { generateAIArray } from '../../utils/setInsuredArray';
import isUnderwriter from '../../utils/is-underwriter';
import AdditionalDocument from '../../submissions/components/AdditionalDocument';

class Form extends Component {
    constructor(props) {
        super(props);
        let _90backday = new Date();
        const eff_Date = new Date(this.props.submission.anticipatedStartDate).getTime();
        _90backday = new Date().setDate(_90backday.getDate()-91);
        const finish_Date = new Date(this.props.submission.anticipatedFinishDate).getTime();
        const curr_Date = new Date().getTime();
        const isValidEffDate= this.props.person.isUnderwriter && ((eff_Date >_90backday) && (finish_Date > curr_Date));
        const title= isValidEffDate? 'Submission has expired due to inactivity. ': 'Submission has expired due to inactivity. The effective date will need to be updated before a new quote can be generated'

        this.state = {
            confirmation: false,
            submission: this.props.submission,
            validationModal: false,
            cancelModal: false,
            show: !this.props.person.isUnderwriter && utils.submission.hasExpired(props.submission.updatedAt)? true : undefined,
            isActiveBrokerage: true,
            modelTitle: this.props.person.isUnderwriter? title: 'Submission has expired due to inactivity. Please re-enter through clearance',
            disabled: false,
            requiredFields: [],
            commissionValue: this.props.submission.commission
                ? this.props.submission.commission
                : '',
            isBrokerageSelectedId: true,
            hasExpired: utils.submission.hasExpired(props.submission.updatedAt),
            selectedRelations: {},
            noSupplementTrigger: [],
            disableOtherField: [],
            scrollToRequiredFields: false,
        };

        this.handleSubmitQuote = this.handleSubmitQuote.bind(this);
        this.handleCancelQuote = this.handleCancelQuote.bind(this);
        this.handleSubmitForReview = this.handleSubmitForReview.bind(this);
        this.handleValidationOk = this.handleValidationOk.bind(this);
        this.handleRelationChange = this.handleRelationChange.bind(this);
        this.handleDisableButton =  this.handleDisableButton.bind(this);
        this.handleOtherFieldChange = this.handleOtherFieldChange.bind(this);
        this.handleDisableFieldChange = this.handleDisableFieldChange.bind(this);


        this.handleCancelDialog = this.handleCancelDialog.bind(this);
        this.handleCancelOK = this.handleCancelOK.bind(this);
        this.handleHideModal = this.handleHideModal.bind(this);
        this.handleCancelBack = this.handleCancelBack.bind(this);
        this.handleBrokerChange = this.handleBrokerChange.bind(this);
        this.handleSetScrollToRequired = this.handleSetScrollToRequired.bind(this);
    }

    handleBrokerChange(event) {
        let selectedBrokerage;
        let isBrokerageSelectedId;

        if (event === null) {
            selectedBrokerage = { brokerId: null };
            isBrokerageSelectedId = false;
        } else {
            selectedBrokerage = { brokerId: event.value };
            isBrokerageSelectedId = true;
        }
        this.setState(
            {
                isBrokerageSelectedId
            },
            () => {
                this.props.impersonateBrokerId(selectedBrokerage.brokerId);
            }
        );
    }
    componentWillMount() {
        const { person } = this.props;

        if (!this.props.submission || !this.props.submission.type) {
            this.props.dispatch(push(routes.SUBMISSIONS));
        }

        this.props.dispatch({
            type: CHANGE_SUBMISSION,
            payload: {
                submission: this.props.submission || {},
                submissionFormParams: !person.isUnderwriter
                    ? utils.submission.getSubmissionFormParams(this.props.submission)
                    : {}
            }
        });
        if (person.isUnderwriter) {
            this.props.fetchBrokerages(this.props.user);
        }
    }
    componentWillReceiveProps(nextProps) {
        if(!!this.props.submission && !!this.props.submission.brokerId) {
        const brokerArray = nextProps.brokers.find(brokerage => this.props.submission.brokerId==brokerage.brokerId)
        const isActiveBrokerage = nextProps.brokers && nextProps.brokers.length > 0 ? !!brokerArray : true;
            if(isActiveBrokerage !== this.state.isActiveBrokerage) {
                this.setState({
                    showAgencyAlert: !isActiveBrokerage,
                    isActiveBrokerage,
                    modelTitle: !isActiveBrokerage ? 'The submission is disabled as it belongs to inactive broker company' : this.state.modelTitle,
                    isBrokerageSelectedId: !isActiveBrokerage ? false : true,
                })
            }
        }
        if(this.state.show === undefined && nextProps.brokers && nextProps.brokers.length > 0) {
            this.setState({
                show: utils.submission.hasExpired(this.props.submission.updatedAt) ? true : false,
            })
        }
    }

    componentDidMount() {
        this.props.dispatch({ type: CHANGE_SUBMISSION_STATUS, status: SUBMISSION_STATUS.CREATING });

        if (this.props.person.isUnderwriter && this.props.submission.brokerId) {
            this.props.impersonateBrokerId(this.props.submission.brokerId);
        }
    }

    handleSubmitQuote() {
        const { person: { isUnderwriter, brokerId }, deductibles } = this.props;
        const { submission } = this.state;

        let updatedSubmission = { ...submission }
        const newAIArray = generateAIArray(this.state.submission);

        updatedSubmission = Object.assign(this.state.submission, newAIArray);

        let isBankSelected = this.state.submission.numberOfBankForms > 0 ? true : false;

        if (isUnderwriter && brokerId) {
            updatedSubmission = { ...updatedSubmission, brokerId }
        }
        let subjectivities = getSubjectivities(submission);

        if (updatedSubmission && !updatedSubmission.ratings){
            updatedSubmission.ratings = {}
        }
        if(updatedSubmission && updatedSubmission.ratings){
            if (!updatedSubmission.ratings[updatedSubmission.type]) {
                updatedSubmission.ratings[updatedSubmission.type] = {};
            }
            if (!updatedSubmission.ratings.options){
                updatedSubmission.ratings.options = {};
            }
        }
        if(subjectivities){
            updatedSubmission.ratings[updatedSubmission.type].subjectivities = subjectivities;
            updatedSubmission.ratings.options.subjectivities = subjectivities;
        }
        const { defaultPreference } = this.props.user;
        if (defaultPreference && submission.type === 'oi'
        && defaultPreference[submission.type] && defaultPreference[submission.type].additional_coverages) {
            const defaultPreferenceList = {};
            defaultPreference[submission.type].additional_coverages.map(list => Object.assign(defaultPreferenceList, {[list]: {selected: true}}))
            subjectivities = updateSubjectivities(updatedSubmission, false, defaultPreferenceList)
            updatedSubmission.ratings[updatedSubmission.type].subjectivities = subjectivities;
            updatedSubmission.ratings.options.subjectivities = subjectivities;
        }
        const subjectivitiesDescription = getSubjectivities(submission,true);
        if(subjectivitiesDescription){
            updatedSubmission.ratings[updatedSubmission.type].subjectivitiesDescription = subjectivitiesDescription;
            updatedSubmission.ratings.options.subjectivitiesDescription = subjectivitiesDescription;
        }
        const u650Exclusions = getExclusionU650();
        if( u650Exclusions) {
            updatedSubmission.ratings[updatedSubmission.type].u650Exclusions = u650Exclusions;
            updatedSubmission.ratings.options.u650Exclusions = u650Exclusions;
        }
        const NYSplitDeductibleZipCodes = deductibles.zipcodes;
        const isNYDeductible = NYSplitDeductibleZipCodes.includes(parseInt(this.state.submission.projectAddress.projectZipcode));
        Object.assign(updatedSubmission, { manuallySetPricing: 'false' }, { isMinPremium : false}, {hnoaRequired : (!!submission.coverages) ? ((!! submission.coverages.gl.additional.hnoaPremium) ?
            submission.coverages.gl.additional.hnoaPremium.selected : false) : false }, {isNYDeductible}, {isBankSelected});

            if(!!isBankSelected && isBankSelected == true && !!updatedSubmission.coverages) {
                updatedSubmission.coverages.gl.additional.bankPremium = {selected : true}
            }
            else if (!!updatedSubmission.coverages) {
                updatedSubmission.coverages.gl.additional.bankPremium = {selected : false}
            } else{}
            if(this.props.submission.additionalInsured === "true" && !!updatedSubmission.coverages) {
                updatedSubmission.coverages.gl.additional.additionalInsureds = {selected: true}
            }
            else if (!!updatedSubmission.coverages){
                updatedSubmission.coverages.gl.additional.additionalInsureds = {selected: false}
            }else{}

        if (submission.otherSubcontractorsPaid === 'true') {
            Object.assign(updatedSubmission, {isDeductibleWarranty: false})
            if (submission.coverages && submission.coverages.gl.base === 'deductibleWarranty') {
                if (submission.projectAddress.projectState !== 'New York') {
                    Object.assign(updatedSubmission.coverages.gl, {base: 'conditional'})
                } else {
                    Object.assign(updatedSubmission.coverages.gl, {base: 'standard'})
                }
            }
        } else {
            Object.assign(updatedSubmission, {isDeductibleWarranty: true})
        }
        Object.assign(updatedSubmission, {quoteDrafted : 'true'})
        if (updatedSubmission.transactionStatus) {
            delete updatedSubmission.transactionStatus;
        }
        this.props.dispatch({ type: CHANGE_SUBMISSION, payload: { submission: updatedSubmission } });
        this.setState({
            confirmation: false
        });
        if (submission.type == 'ocp' && !!submission.excessLimitAmount) {
            submission.excessLimitAmount = 0;
        }
        if (!!submission.id) {
            this.props.dispatch(push(routes.QUOTE.replace(':id', submission.id)));
        } else {
            this.props.dispatch(push(routes.QUOTE.replace('/:id', '')));
        }
    }

    handleCancelQuote() {
        this.setState({
            ...this.state,
            confirmation: false
        });
    }

    handleDisableButton(value){
        this.setState({
            disabled: value==="err" ? true: false
        })
    }


    async handleRelationChange(value, AI) {
        const selectedRelations=this.state.selectedRelations ? this.state.selectedRelations : {};
        const newData = {};
        newData[AI] = value;
        Object.assign(selectedRelations, newData);
        await this.setState({
            selectedRelations
        });
    }

   async handleOtherFieldChange(value, field, affectedField) {
       const newData_ = []
       newData_.push(affectedField);
       await this.setState({
        noSupplementTrigger: newData_
    });
   }

   async handleDisableFieldChange(value, field, disableOtherField) {
    const newData_ = [];
    newData_.push(disableOtherField)
    await this.setState({
        disableOtherField: newData_
    })
}

    handleSubmitForReview(sub, controlGroups, requiredFields) {
        const { person } = { ...this.props };
        const { commissionValue, isBrokerageSelectedId, submission } = { ...this.state };
        requiredFields = requiredFields.concat(validation.execute(sub, person.isUnderwriter, submission.type));
        if (
            requiredFields.length > 0 ||
            (person.isUnderwriter &&
                submission.id &&
                (commissionValue === '' || !isBrokerageSelectedId))
        ) {
            this.setState({
                ...this.state,
                requiredFields,
                validationModal: true,
                scrollToRequiredFields: requiredFields.length > 0 ? true : false,
            });
        } else {
            const commission = { commission: commissionValue };
            const newAIArray = generateAIArray(sub);
            let submission = Object.assign(this.state.submission, sub, commission);
            if (!newAIArray.additionalInsuredArray) {
                delete submission.additionalInsuredArray;
                delete submission.numberOfInsureds;
                delete submission.numberOfAIForms;
                delete submission.numberOfBankForms;
                delete submission.numberOfBankAIForms;
            }
            if (!!submission.totalAdjustedCommission) {
                submission.totalAdjustedCommission = submission.adjustedCommission  - submission.commission;
            }
            this.props.dispatch({ type: CHANGE_SUBMISSION, payload: { submission } });
            this.setState({
                ...this.state,
                requiredFields: [],
                submission,
                confirmation: true,
                scrollToRequiredFields: false,
            });
        }
    }

    handleValidationOk() {
        this.setState({
            ...this.state,
            validationModal: false
        });
    }

    handleCancelDialog() {
        this.setState({
            ...this.state,
            cancelModal: true
        });
    }

    handleCancelOK() {
        this.setState({
            ...this.state,
            cancelModal: false,
            modelTitle: '',
            showAgencyAlert: false,
            show: false,
        });
        if (!this.state.showAgencyAlert) {
            this.props.dispatch(push(routes.SUBMISSIONS));
        }

    }

    handleHideModal() {
        this.setState({
       modelTitle: '',
       show: false
        })
    }

    handleCancelBack() {
        this.setState({
            ...this.state,
            cancelModal: false
        });
    }
    commissionChange = event => {
        this.setState({
            commissionValue: event.target.value
        });
    };

    handleSetScrollToRequired = (scrollTo) => {
        this.setState({
            scrollToRequiredFields: scrollTo
        });
    };

    render() {
        const { person } = { ...this.props };
        const { commissionValue, submission, isBrokerageSelectedId, hasExpired } = { ...this.state };
        if (!submission) {
            return null;
        }
        const ratingProduct = getRatingProduct(submission.type);
        const arr=["TBD", "N/A"];
        const disable= arr.includes(this.state.commissionValue && this.state.commissionValue.toString().toUpperCase().replace(/\s/g, ''))
        const submissionFormParams = !person.isUnderwriter
            ? utils.submission.getSubmissionFormParams(this.props.submission)
            : {};

        const requiredList = () => {
            const { submission } = this.state;

            let errorBrokerageMessage = [];
            if (person.isUnderwriter && submission.id) {
                if (!isBrokerageSelectedId) {
                    const errorIsBrokerageSelectedMessage = (
                        <li
                            key={`brokageLocation_${new Date().getTime()}`}
                            className="remainingField"
                        >
                            Please insert the Brokage Location
                        </li>
                    );
                    errorBrokerageMessage.push(errorIsBrokerageSelectedMessage);
                }
                if (commissionValue === '') {
                    const errorCommissionValueMessage = (
                        <li key={`brokageValue_${new Date().getTime()}`} className="remainingField">
                            Please Insert Commission
                        </li>
                    );
                    errorBrokerageMessage.push(errorCommissionValueMessage);
                }
            }
            let requiredListFrom = this.state.requiredFields.map(r => {
                const fieldText = r.questionId == '2c' ? 'State' : r.text;
                return (
                    <li key={r.questionId} className="remainingField">
                        {fieldText || r.placeholder}
                    </li>
                );
            });
            return [errorBrokerageMessage, ...requiredListFrom];
        };

        if (!ratingProduct) {
            return <div />;
        }

        const passedDiv = (
            <div className="common-notification success">
                <div className={'sub-header-firstRow clearance-pass'}>Clearance passed</div>
                <div className="sub-header-Complete">
                    Complete this application for a quick pricing summary
                </div>
            </div>
        );

        const boundSub = (
            <div className="common-notification success">
                <div className={'sub-header-firstRow clearance-pass'}>Bind Requested</div>
                <div className="sub-header-Complete">
                    This submission is being or has been bound. Please contact underwriter for additional information.
                </div>
            </div>
        )

        const underReviewDiv = (
            <div className="common-notification warn">
                <div className={'sub-header-firstRow clearance-review'}>Clearance is pending</div>
                <div className={'sub-header-secondRow clearance-review'}>
                    Submit application to receive a quote after a manual review.
                </div>
            </div>
        );

        // removing matches from formbuilder to allow for projectAddress
        const formBuildSubmission = Object.assign({}, submission);
        delete formBuildSubmission['clearanceMatches'];
        const isBound = !!submission.isBinded ? submission.isBinded : false;

        const edgeNumber = utils.submission.getEdgeNumber(this.props.submission);
        const type = submission.type

        return (
            <div className="productChoice routeContainer container">
                <div className="row">
                    <div className="submission-status-div">
                        {isBound == true && type == "ocp" ? boundSub : (this.props.submission.clearanceStatus == 'pass'
                            ? passedDiv
                            : underReviewDiv)
                        }
                    </div>
                    <br />
                    <div className="formHeader">
                        {ratingProduct.name} Application
                        <div className="formSubHeader">
                            You can submit this application online.
                            {edgeNumber && (
                                <span className="subheader-doc-number">#{edgeNumber}</span>
                            )}
                        </div>
                    </div>
                    {submission.id && (
                        <div className="clearance_brokerage_dropdown pt mt">
                            <Row>
                                <Col md={5}>
                                    {person.isUnderwriter && (
                                        <div>
                                            <label className="commission-label">
                                                Brokerage Office
                                            </label>
                                            <SelectSearchContainer
                                                options={this.props.brokers}
                                                labelColumn={'name'}
                                                valueColumn={'brokerId'}
                                                value={this.props.person.brokerId}
                                                onChange={this.handleBrokerChange}
                                                id="clearanceBrokerageDropdownEdit"
                                            />
                                        </div>
                                    )}
                                    <label className="commission-label">Commission</label>
                                    <input
                                        className="form-control commission-input"
                                        value={this.state.commissionValue}
                                        onChange={this.commissionChange}
                                        readOnly={!person.isUnderwriter}
                                    />
                                    {disable && <div style={{ fontSize: '12px', color: 'red', lineHeight: 2.0}}>{`Please provide valid details. Texts like 'TBD', 'N/A' is not acceptable.`}</div>}
                                </Col>
                            </Row>
                        </div>
                    )}
                    <FormBuilder
                        data={ratingProduct.formJSON}
                        Validation={ratingProduct.Validation}
                        initialValues={formBuildSubmission}
                        initialParams={submissionFormParams}
                        submitTitle="Review Submission"
                        handleSubmit={this.handleSubmitForReview}
                        selectedRelations={this.state.selectedRelations}
                        handleRoleChange={this.handleRoleChange}
                        handleRelationChange={this.handleRelationChange}
                        noSupplementTrigger={this.state.noSupplementTrigger}
                        disableOtherField={this.state.disableOtherField}
                        handleOtherFieldChange={this.handleOtherFieldChange}
                        handleDisableFieldChange={this.handleDisableFieldChange}
                        handleDisableButton={this.handleDisableButton}
                        isUnderwriter={isUnderwriter(this.props.user)}
                        requiredFields={this.state.requiredFields}
                        handleSetScrollToRequired={this.handleSetScrollToRequired}
                        scrollToRequiredFields={this.state.scrollToRequiredFields}
                        additionalDocuments={!this.props.person.isUnderwriter ? <AdditionalDocument additionalDocumentsId={submission.additionalDocumentsId}/> : ''}
                        submissionButtons={() => (
                            (isBound == true && type == "ocp") || this.state.disabled || disable ?
                            <Button className="btn" type="submit" disabled={true} tabIndex="-1" onFocus={e => e.target.blur()}>
                                    Next
                            </Button> :
                            <ButtonGroup>
                                <Button className="btn" type="submit" tabIndex="-1" onFocus={e => e.target.blur()}>
                                    Next
                                </Button>
                                <a
                                    role="link"
                                    className="cancelLink"
                                    onClick={this.handleCancelDialog}
                                >
                                    Cancel
                                </a>
                            </ButtonGroup>
                        )}
                    />

                    <DialogBox
                        custom_class="confirmationDialog"
                        title="Is your data correct?"
                        subtitle="Double check your values and move to Pricing Page"
                        show={this.state.confirmation}
                        onHide={this.handleCancelQuote}
                    >
                        <div>
                            <ConfirmationModal
                                form={ratingProduct.formJSON}
                                submission={submission}
                            />

                            <ButtonGroup>
                                <Button
                                    id="btn-get-pricing"
                                    className="btn"
                                    onClick={this.handleSubmitQuote}
                                >
                                    Go to Pricing Page
                                </Button>
                                <Button className="btn secondary" onClick={this.handleCancelQuote}>
                                    Cancel
                                </Button>
                            </ButtonGroup>
                        </div>
                    </DialogBox>

                    <DialogBox
                        custom_class="confirmationDialog"
                        title="Please fill out all required fields."
                        show={this.state.validationModal}
                        onHide={this.handleValidationOk}
                    >
                        <div>
                            <h4>Here are your remaining questions:</h4>
                            <ul className="section">{requiredList()}</ul>

                            <br />

                            <ButtonGroup>
                                <Button className="btn" onClick={this.handleValidationOk}>
                                    Return to the Form
                                </Button>
                            </ButtonGroup>
                        </div>
                    </DialogBox>

                    <DialogBox
                        custom_class="cancelDialog"
                        title="Are you sure you want to cancel?"
                        show={this.state.cancelModal}
                        onHide={this.handleCancelBack}
                    >
                        <div>
                            <p>Canceling now will remove all changes without saving.</p>

                            <ButtonGroup>
                                <Button className="btn" onClick={this.handleCancelOK}>
                                    Continue
                                </Button>
                                <Button className="btn secondary" onClick={this.handleCancelBack}>
                                    Return to the Form
                                </Button>
                            </ButtonGroup>
                        </div>
                    </DialogBox>
                    <DialogBox
                        title={this.state.modelTitle}
                        show={this.state.show || this.state.showAgencyAlert}
                        onHide={this.handleCancelOK}
                    >
                    {this.state.isActiveBrokerage ? (person.isUnderwriter ? <Button onClick={this.handleHideModal}>Continue</Button> :<Button onClick={this.handleCancelOK}>Return to Submissions</Button>) : ''}
                    </DialogBox>
                </div>
            </div >
        );
    }
}

Form.propTypes = {
    dispatch: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired
};

const connectedForm = connect(
    store => {
        return {
            user: store.user,
            person: store.person,
            brokers: store.brokerages.items,
            deductibles: store.deductibles
        };
    },
    { fetchBrokerages, impersonateBrokerId }
)(Form);
export default withSubmission(connectedForm);

